'use es6';

import { getDndAreaRowElementByIndex, getDndAreaCellElement } from 'layout-dnd-utils/dom/dndAreaDomSelectors';

/**
 * Helper to get the appropriate cell or row DOM elements from an arbitrary tree node
 * @param  {Cell|Row} node
 * @return {Array} array of DOM elements
 */
export const getLayoutTreeElements = node => {
  let element;
  if (node.isCell()) {
    element = getDndAreaCellElement(node.getName());
  } else if (node.isRow()) {
    element = getDndAreaRowElementByIndex(node.getParentName(), node.getParent().getRowNames().indexOf(node.getName()));
  }
  if (element) {
    return [element];
  }
  return [];
};